<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="mat-typography">
    <p>{{data.confirmationMessage}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false">{{localizationKeys.aumico_button_cancel | i18next}}</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
        {{localizationKeys.aumico_button_confirm | i18next}}
    </button>
</mat-dialog-actions>
